module.exports = __webpack_public_path__ + "img/handraw_panier blanc.7ae0ee39.svg";